export default "__VITE_ASSET__BguTZhNe__"